module.exports = __webpack_public_path__ + "static/media/system-layers.9adbe3f8.svg";